module.exports = __webpack_public_path__ + "img/orderBg.684c5490.png";